import { type FC } from 'react';

import styles from './MainCard.css';

type MainCardProps = {
  title: string;
  description: string;
};

export const MainCard: FC<MainCardProps> = ({ title, description }) => (
  <div className={styles['container']} data-testid="pik-in-numbers-main-card">
    <span className={styles['title']} data-testid="pik-in-numbers-main-card-title">
      {title}
    </span>
    <div className={styles['image']} data-testid="pik-in-numbers-main-card-chart">
      <div className={styles['rectangle-container']}>
        <div className={styles['rectangle']} />
        <span className={styles['rectangle-text']} data-testid="pik-in-numbers-main-card-chart-value-80">
          80
        </span>
      </div>
      <div className={styles['rectangle-container']}>
        <div className={styles['rectangle']} />
        <span className={styles['rectangle-text']} data-testid="pik-in-numbers-main-card-chart-value-120">
          120
        </span>
      </div>
      <div className={styles['rectangle-container']}>
        <div className={styles['rectangle']} />
        <span className={styles['rectangle-text']} data-testid="pik-in-numbers-main-card-chart-value-150">
          150
        </span>
      </div>
    </div>
    <span className={styles['description']} data-testid="pik-in-numbers-main-card-description">
      {description}
    </span>
  </div>
);
